import React, { Component } from "react";
import Container from "@/components/Container";
import FormCreate from "@/components/FormCreate/index";
import { Form, InputNumber, Button, Spin } from "antd";
import { connect } from "dva";
import FormList from "./FormList";
import styles from "./index.less";

@Form.create()
@connect(({ patrolSetting }) => ({
  ...patrolSetting
}))
class index extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: "patrolSetting/fetchPatrolTimes"
    });
  }

  checkNum = (rule, value, callback) => {
    const { boardNum, noBoardNum } = value;
    if (boardNum === null || noBoardNum === null) {
      callback("请输入巡查次数");
      return;
    }
    callback();
  };

  // 保存
  handleSubmitTimes = () => {
    const { dispatch, form } = this.props;
    const { validateFields } = form;
    validateFields((err, values) => {
      if (!err) {
        const { patrolTimes } = values || {};
        dispatch({
          type: "patrolSetting/fetchSetPatrolTimes",
          params: {
            ...patrolTimes
          }
        });
      }
    });
  };

  renderFooterBtn = () => {
    const footerParams = {
      states: !0,
      demFooter: (
        <Button type="primary" onClick={this.handleSubmitTimes}>
          保存
        </Button>
      )
    };
    return footerParams;
  };

  render() {
    const { form, boardNum, noBoardNum, spinProps } = this.props;
    const { getFieldDecorator } = form;
    const containerProps = {
      breStates: true,
      version: 2,
      defaultPadding: true,
      footerParams: this.renderFooterBtn()
    };
    return (
      <Container {...containerProps}>
        <div className={styles.root}>
          <Spin {...spinProps}>
            <div className="title">巡查设置</div>
            <FormCreate>
              <Form.Item label="巡查次数设置">
                {getFieldDecorator("patrolTimes", {
                  initialValue: {
                    boardNum: boardNum || 0,
                    noBoardNum: noBoardNum || 0
                  },
                  rules: [{ required: true }, { validator: this.checkNum }]
                })(<FormList />)}
              </Form.Item>
            </FormCreate>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default index;
